import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getPinList = (payload, callback) =>
  req.list(
    c.GET_PIN,
    'api/v1/administrators/real_property_taxes/settings/property_index_number',
    payload,
    callback
  );

export const getSinglePin = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_PIN,
    'api/v1/administrators/real_property_taxes/settings/property_index_number',
    payload,
    callback
  );

export const createPin = (payload, callback) =>
  req.create(
    c.CREATE_PIN,
    'api/v1/administrators/real_property_taxes/settings/property_index_number',
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Created !');
      if (callback) callback();
    }
  );

export const updatePin = (id, payload, callback) =>
  req.update(
    c.UPDATE_PIN,
    `api/v1/administrators/real_property_taxes/settings/property_index_number/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );
